<app-review-detail-card
  [title]="'createShipment.reviewAndPay.cards.packaging' | translate"
  editHref="/package"
  testId="review-packaging"
  [showEdit]="showEdit()"
  (editRequested)="editRequested.emit($event)"
>
  <div class="review-packaging-summary__rows">
    <div class="review-packaging-summary__row">
      <puro-typography component="span" variant="body2" class="review-packaging-summary__label">
        {{ 'createShipment.reviewAndPay.packaging.type' | translate }}
      </puro-typography>
      <puro-typography component="span" variant="body2">
        {{ view().typeI18nKey | translate }}
      </puro-typography>
    </div>
    <div class="review-packaging-summary__row">
      <puro-typography component="span" variant="body2" class="review-packaging-summary__label">
        {{ 'createShipment.reviewAndPay.packaging.totalPieces' | translate }}
      </puro-typography>
      <puro-typography component="span" variant="body2">{{ view().totalPieces }}</puro-typography>
    </div>
    <div class="review-packaging-summary__row">
      <puro-typography component="span" variant="body2" class="review-packaging-summary__label">
        {{ 'createShipment.reviewAndPay.packaging.totalWeight' | translate }}
      </puro-typography>
      <puro-typography component="span" variant="body2">
        {{ view().weightDisplay }}
        {{ 'createShipment.reviewAndPay.packaging.' + view().weightUnit | translate }}
      </puro-typography>
    </div>
    @if (view().specialHandlingRows.length === 0) {
      <div class="review-packaging-summary__row">
        <puro-typography component="span" variant="body2" class="review-packaging-summary__label">
          {{ 'createShipment.reviewAndPay.packaging.specialHandling' | translate }}
        </puro-typography>
        <puro-typography component="span" variant="body2">
          {{ 'createShipment.reviewAndPay.packaging.no' | translate }}
        </puro-typography>
      </div>
    } @else {
      <div
        class="review-packaging-summary__special-handling"
        data-testid="review-packaging-special-handling"
      >
        <puro-typography
          component="span"
          variant="body2"
          class="review-packaging-summary__label review-packaging-summary__special-handling-heading"
        >
          {{ 'createShipment.reviewAndPay.packaging.specialHandling' | translate }}
        </puro-typography>
        <div class="review-packaging-summary__special-handling-rows">
          @for (row of view().specialHandlingRows; track row.typeKey) {
            <div class="review-packaging-summary__row review-packaging-summary__row--nested">
              <puro-typography
                component="span"
                variant="body2"
                class="review-packaging-summary__nested-label"
              >
                {{ 'createShipment.reviewAndPay.packaging.types.' + row.typeKey | translate }}
              </puro-typography>
              <puro-typography component="span" variant="body2">
                @if (row.pieceCount === 1) {
                  {{ 'createShipment.reviewAndPay.packaging.pieceCountOne' | translate }}
                } @else {
                  {{
                    'createShipment.reviewAndPay.packaging.pieceCountOther'
                      | translate: { count: '' + row.pieceCount }
                  }}
                }
              </puro-typography>
            </div>
          }
        </div>
      </div>
    }
  </div>
</app-review-detail-card>
